interface CategoryCard {
  name: string;
  url: string;
}

interface Event {
  name: string;
}
interface DiscoverView {
  storyUrl: string;
  categories: Array<CategoryCard>;
  events: Array<Event>;
}

const defaultDiscoverView = {
  categories: [],
  events: [],
  storyUrl: "",
};

export { DiscoverView, CategoryCard, Event, defaultDiscoverView };
